export const IslamicStar = ({
  className,
}: {
  className?: string;
}): React.ReactElement => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Green background: upright square */}
      <rect x="3" y="3" width="14" height="14" fill="currentColor" />
      {/* Green background: rotated square — together they form the 8-pointed star */}
      <rect
        x="3"
        y="3"
        width="14"
        height="14"
        fill="currentColor"
        transform="rotate(45 10 10)"
      />
      {/* White crescent moon + small star */}
      <g transform="translate(6,6) scale(1.25)" fill="white">
        <path d="M5.7243 5.485C5.47061 5.55127 5.20852 5.58499 4.94609 5.58499C3.79846 5.58499 2.75071 4.95634 2.2114 3.94508C1.53436 2.67448 1.81379 1.12222 2.89143 0.169883L3.08377 0L2.8354 0.0648804C2.59032 0.128701 2.35365 0.220931 2.13218 0.338993C0.565865 1.17412 -0.0293783 3.12773 0.805732 4.69434C1.36641 5.74635 2.45607 6.4 3.64892 6.4C4.17279 6.4 4.6955 6.26884 5.16065 6.0209C5.38212 5.90282 5.59038 5.75816 5.78036 5.59032L5.97268 5.42012L5.7243 5.485Z" />
        <path d="M3.75772 3.66523L4.3385 3.35985L4.91897 3.66523L4.80813 3.01872L5.27787 2.56079L4.62868 2.46633L4.3385 1.87842L4.04821 2.46644L3.39893 2.56089L3.86866 3.01882L3.75772 3.66523Z" />
      </g>
    </svg>
  );
};
